import { render, staticRenderFns } from "./ContactNote.vue?vue&type=template&id=4f750582&scoped=true&"
import script from "./ContactNote.vue?vue&type=script&lang=js&"
export * from "./ContactNote.vue?vue&type=script&lang=js&"
import style0 from "./ContactNote.vue?vue&type=style&index=0&id=4f750582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f750582",
  null
  
)

export default component.exports